import React from "react"
import { Form, Card, InputGroup, Button } from "react-bootstrap"
import withHooks from "./WithHooks"
import { strToSnakeCase, strToUpperSnakeCase } from "../js/string_utils"

class ListOptionsCard extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.debug("const_props:", this.props)

    this.state = {}
    this.dMgr.debug("init_state:", this.state)
  }

  render() {
    this.dMgr.rendering()

    let actions = []
    if (this.props.noAddButton !== true && this.props.RightsManager.userHasRight(strToUpperSnakeCase(this.props.entityType) + ":CREATE")) {
      actions.push(
        <div className="margin-left-20" key={"btn-add-" + this.props.entityType}>
          <Button
            id={"btn-add-" + this.props.entityType}
            onClick={() =>
              this.props.router.nav({
                prefix: "admin",
                entitiesType: this.props.entitiesType,
                actionName: "add",
                referrerUrl: "/admin/" + strToSnakeCase(this.props.entitiesType),
              })
            }
            variant="success"
            size="sm"
            className="margin-right-5"
          >
            {this.props.t("action.add")}
          </Button>
        </div>,
      )
    }

    let toRender = (
      <Card bg="dark" text="white" className="box-shadow-lvl3">
        <Card.Body>
          {this.props.entitiesType !== undefined && <div className="card-entity-title">{this.props.t("entity." + this.props.entitiesType)}</div>}
          {actions.length > 0 && (
            <>
              <br />
              <div className="card-entity-subtitle">
                {this.props.t("app.actions")}
                {this.props.t("app.dbp")}
              </div>
              {actions}
            </>
          )}
          <br />
          <div className="card-entity-subtitle">
            {this.props.t("app.filters")}
            {this.props.t("app.dbp")}
          </div>
          <div className="margin-left-20">
            {Object.keys(this.props.filters).map((key) => {
              let filter = this.props.filters[key]
              if (filter.type === "checkbox") {
                return (
                  <Form.Group key={"key_" + filter.name}>
                    <Form.Check
                      id={filter.name}
                      name={filter.name}
                      type="checkbox"
                      label={filter.label}
                      checked={filter.checked}
                      onChange={(e) => {
                        let state = {}
                        state[filter.name] = e.target.checked
                        this.props.listFiltersUpdate(state)
                      }}
                    />
                  </Form.Group>
                )
              } else if (filter.type === "text") {
                return (
                  <InputGroup data-bs-theme="dark" className="mb-3" key={"key_" + filter.name}>
                    <Form.Control
                      id={"filter_" + filter.name}
                      placeholder={filter.label}
                      aria-label={filter.label}
                      value={filter.value}
                      onChange={(e) => {
                        let state = {}
                        state[filter.name] = e.target.value
                        this.props.listFiltersUpdate(state)
                      }}
                    />
                  </InputGroup>
                )
              } else if (filter.type === "select") {
                return (
                  <Form.Select
                    key={"key_" + filter.name}
                    size="sm"
                    data-bs-theme="dark"
                    value={filter.value}
                    className="margin-top-15"
                    onChange={(e) => {
                      let value = e.target.value
                      if (value === "true" || value === "false") {
                        value = value === "true"
                      }

                      let state = {}
                      state[filter.name] = value
                      this.props.listFiltersUpdate(state)
                    }}
                  >
                    {filter.options.map((option, key) => (
                      <option key={"key_option_" + filter.name + key} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                )
              }
              return null
            })}
          </div>
        </Card.Body>
      </Card>
    )

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(ListOptionsCard)
